import React, {useState, Fragment, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {makeStyles} from "@material-ui/core/styles";
import Fab from "@material-ui/core/Fab";
import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import StorageIcon from "@material-ui/icons/Storage";
import AttachmentChip from "../../../Chip/AttachmentChip";
// Custom Style
import {
    circulationFileZoneContentStyle
} from "../../../../styles/jss/components/circulation/circulationFileZoneContentStyle";
// Fetch Data
import {fileDownload} from "../../../../dataSource/fileManager";
import AttachmentDeletedChip from "../../../Chip/AttachmentDeletedChip";

const useStyles = makeStyles((theme) => circulationFileZoneContentStyle(theme));
const PilFileZoneContentStageOne = (props) => {
    const pilDataRedux = useSelector((state) => state.pilDetailsRedux);
    const classes = useStyles();
    const {open, fileRemoveAction, viewFileAction, uploadable, disabled} = props;

    const downloadFileAction = (fileCat, fileSeq) => {
        fileDownload(fileCat, fileSeq).then((res) => {
            console.log("*****************************************************************************");
            console.log("System Module: Document Submission");
            console.log("Message: File download successful.");
            console.log("*****************************************************************************");
        });
    };

    return (<Fragment>
        <Grid container spacing={1}>
            {pilDataRedux !== null && pilDataRedux.uploadFiles ? pilDataRedux.uploadFiles
                .filter((a) => a.stage === "1")
                .map((res, index) => {
                    return (<div key={index} style={{width: "100%", margin: "10px"}}>
                        <Grid item xs={1}>
                            <Chip
                                size="small"
                                variant="outlined"
                                color="primary"
                                label={`V${res.version}`}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            {res.status === "Y" ?
                                <AttachmentChip
                                    key={index}
                                    id={res.file_seq}
                                    filename={res.filename}
                                    fileSize={res.filesize}
                                    fileExtension={res.extension}
                                    viewFileAction={() => viewFileAction("master", res.file_seq, res.filename)}
                                    downloadFileAction={() => {
                                        downloadFileAction("master", res.file_seq);
                                    }}
                                    fileRemoveAction={!disabled ? () => {fileRemoveAction(res)} : null}
                                />
                                : <AttachmentDeletedChip
                                    key={index}
                                    id={res.file_seq}
                                    filename={res.filename}
                                    fileSize={res.filesize}
                                    fileExtension={res.extension}
                                />}
                        </Grid>
                    </div>);
                }) : ""}
        </Grid>

        <Box style={{textAlign: "center", minHeight: "75px"}}>
            {uploadable && !disabled ? <Tooltip title="Add File From Hard Disk">
                <Fab
                    color="primary"
                    size="small"
                    aria-label="add_file"
                    className={classes.addFileBtn}
                    onClick={open}
                >
                    <StorageIcon/>
                </Fab>
            </Tooltip> : <></>}
        </Box>

    </Fragment>);
};

export default PilFileZoneContentStageOne;
